import { GiOrganigram } from 'react-icons/gi'

import DepartmentCrud from '../Components/DepartmentCrud'
import { DepartmentResource } from '../Resources/DepartmentResource'

import type { IPageConfig } from '@/Core/Contracts/Loaders/IPageConfig'

export default function DepartmentPage() {
    document.title = DepartmentResource?.title

    return (
        <>
            <DepartmentCrud />
        </>
    )
}

export const pageConfig: IPageConfig = {
    title: 'Структура компанії',
    icon: <GiOrganigram size={20} />,
}
